import { render, staticRenderFns } from "./ProtoItem.vue?vue&type=template&id=14cd7d67&scoped=true&"
import script from "./ProtoItem.vue?vue&type=script&lang=js&"
export * from "./ProtoItem.vue?vue&type=script&lang=js&"
import style0 from "./ProtoItem.vue?vue&type=style&index=0&id=14cd7d67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cd7d67",
  null
  
)

export default component.exports